import * as d3 from 'd3';
import * as d3tip from 'd3-tip';
import { get, toNumber } from 'lodash';

export const getTooltipHtml = (title, value, intl) => {
  const displayValue = isNaN(value) ? value : intl.formatNumber(value);
  const recallsText = intl.formatMessage({ id: 'recalls' });
  // https://stackoverflow.com/questions/15837650/why-is-my-tooltip-flashing-on-and-off
  return (`
    ${/* <div class="tooltip-arrow" style="left: 50%;"></div> */''}
    <div class="tooltip-inner" style="max-width: none; pointer-events: none;">
      <h5 class="tooltip__title" style="pointer-events: none;">
        ${title}
      </h5>
      <p style="pointer-events: none;">
        ${recallsText}: ${displayValue}
      </p>
    </div>
  `);
};

export const createTooltip = ({ intl, isMovingX = true, isMovingY = true }) => {
  const tip = d3tip.default()
    .attr('class', 'tooltip tooltip--dark fade top in')
    .offset([0, 0])
    .direction('n')
    .html((node) => {
      const label = get(node, 'data.label', get(node, 'label', ''));
      const recallCount = get(node, 'data.recallCount', get(node, 'recallCount', ''));
      return getTooltipHtml(label, recallCount, intl);
    });

  let tipOffsetX = 0;
  let tipOffsetY = 0;
  tip.move = () => {
    const { pageX, pageY } = d3.event;
    if (tipOffsetX === 0 && tipOffsetY === 0) {
      const { width, left, top } = d3.event.target.getBoundingClientRect();
      const prevTipLeft = toNumber(tip.style('left').replace('px', '')); // At middle of the target due to .offset([0, 0]) and .direction('n')
      const targetMiddleX = window.scrollX + left + width / 2;
      const tipHalfWidth = targetMiddleX - prevTipLeft;
      tipOffsetX = tipHalfWidth;

      const prevTipTop = toNumber(tip.style('top').replace('px', '')); // At top of the target due to .offset([0, 0])
      const targetTop = window.scrollY + top;
      const tipHeight = targetTop - prevTipTop;
      tipOffsetY = tipHeight + 5; // https://stackoverflow.com/questions/15837650/why-is-my-tooltip-flashing-on-and-off
    }
    if (isMovingX) {
      tip.style('left', `${pageX - tipOffsetX}px`);
    }
    if (isMovingY) {
      tip.style('top', `${pageY - tipOffsetY}px`);
    }
  };

  const { hide } = tip;
  tip.hide = () => {
    hide();
    tipOffsetX = 0;
    tipOffsetY = 0;
  };

  return tip;
};



// WEBPACK FOOTER //
// ./src/views/dashboard/chart/helpers.js